var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { "ok-disabled": _vm.isUpdatingStatus },
      on: { ok: _vm.performCreditCardPayment },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t("message.confirm_order_payment.credit_card_payment")
            ) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("order-summary-total-short", { attrs: { order: _vm.order } }),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _vm.payment && !_vm.isChangingNewCard
            ? _c(
                "div",
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("message.my_reservations.payment")))
                  ]),
                  _vm._v(" "),
                  _c("payment-small", {
                    staticClass: "mt-3",
                    attrs: { payment: _vm.payment }
                  })
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("payment-form", {
                    ref: "paymentForm",
                    attrs: { paymentData: _vm.paymentData }
                  })
                ],
                1
              ),
          _vm._v(" "),
          _vm.displayLoader
            ? _c("div", { staticClass: "text-center mt-3" }, [
                _c("img", {
                  attrs: { src: "/static/img/ring.gif", width: "60" }
                }),
                _vm._v(
                  " " + _vm._s(_vm.$t("message.button.loading")) + "\n    "
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          attrs: { slot: "modal-cancel" },
          on: {
            click: function($event) {
              _vm.showModal = false
            }
          },
          slot: "modal-cancel"
        },
        [_vm._v(_vm._s(_vm.$t("message.button.close")))]
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-ok" }, slot: "modal-ok" }, [
        _vm._v(
          _vm._s(
            _vm.isLoading || _vm.isUpdating
              ? _vm.$t("message.button.loading")
              : _vm.$t("message.button.submit")
          )
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38a6a130", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a6a130","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/CreditCardPaymentModal.vue
// module id = 1714
// module chunks = 0